import React, { useState } from 'react'
import { useEffect } from "react"
import Axios from '../Axios'
import InnerBanner from '../component/InnerBanner'
import AboutCard from '../component/AboutCard'

const Donate = () => {

  const[donateData,setDonateData] = useState("");
  const[isError, setIsError] = useState("");
  const getApiData = async() =>{
    try{
     const res = await Axios.pgBaseUrl.get('/about-us')
     setDonateData(res.data.data)
    //  console.log(res.data.data)
    }
    catch(error){
       setIsError(error.message)
    }
 }
 useEffect(() => {
  getApiData() 

   
 }, [])

  return (
    <>
    <section>
         <div className="inner-page">
           {isError !== "" && <p className='errorTxt'>{isError}</p>}
           <InnerBanner/>
           <AboutCard aboutData ={donateData} donate/>
         </div>
      </section>
     
    </>
  )
}

export default Donate